// extracted by mini-css-extract-plugin
export default {"burger":"Burger_burger__AwvGD","active":"Burger_active__kYuD5"};